import { Jwt } from '@thingslog/repositories';

const SESSION_USER_KEY = 'decoded_token';

/**
 * The session user is cached in local storage because JwtValidator is instantiated all over the
 * app, including outside of the react tree (axios interceptors), where the auth context is out of
 * reach. It is a cache of GET /api/me - never a credential.
 */
export const getSessionUser = (): Jwt | null => {
  const sessionUserRaw = localStorage.getItem(SESSION_USER_KEY);

  if (!sessionUserRaw) {
    return null;
  }

  try {
    const sessionUser = JSON.parse(sessionUserRaw) as Jwt;
    return Array.isArray(sessionUser?.roles) ? sessionUser : null;
  } catch {
    console.error('Malformed session user in local storage');
    return null;
  }
};

export const setSessionUser = (sessionUser: Jwt): void => {
  localStorage.setItem(SESSION_USER_KEY, JSON.stringify(sessionUser));
};

export const clearSessionUser = (): void => {
  localStorage.removeItem(SESSION_USER_KEY);
};
